import PropTypes from 'prop-types';
import styled from 'styled-components';

import devices from '@/utilities/devices';

const TextContainer = styled.div`
  padding: 2em 8em;
  box-sizing: border-box;

  p {
    font-size: ${props => props.isSector ? '1em' : '1.1em'};
    padding: ${props => props.isSector ? '0em' : '.5em 0 1em'};
  }
  div {
    font-size: ${props => props.isSector ? '1em' : '1em'};
    padding: ${props => props.isSector ? '.3em' : '0em'};
  }

  @media screen and (${devices.mobile}) {
    width: 100%;
    padding: 0em;
    p {
      font-size: ${props => props.isSector ? '.9em' : '1em'};
      padding: ${props => props.isSector ? '.5em 1.7em' : '.5em'};
      text-align: ${props => props.isSector ? 'left' : 'center' };
      line-height: 1.6em;
      margin: auto;
      width: auto;
    }
    div {
      font-size: ${props => props.isSector ? '.9em' : '1em'};
      padding: ${props => props.isSector ? '.5em 2em' : '1.5em 0'};
      line-height: 1.6em;
    }
  }
  @media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
    width: 100%;
    padding: 2em;
    p {
      font-size: ${props => props.isSector ? '1em' : '1.1em'};
      padding: 1em;
      text-align: center;
      line-height: 1.7em;
    }
    div {
      font-size: ${props => props.isSector ? '1em' : '1em'};
      padding: 1em;
      text-align: center;
      line-height: 1.7em;
    }
  }

  @media screen and (${devices.minLaptop}) and (${devices.maxLaptop}) {
    padding: 2em 5em;
    box-sizing: border-box;
    p {
      font-size: ${props => props.isSector ? '.85em' : '.9em'};
      padding: ${props => props.isSector ? '0em' : '.5em 0 1em'};
    }
    div {
      font-size: ${props => props.isSector ? '.85em' : '.9em'};
      padding: ${props => props.isSector ? '0em' : '.5em 0 1em'};
    }
  }
`;

const SectionText = ({children, isSector}) => {

	return (
		<TextContainer isSector={isSector}>
			{children}
		</TextContainer>
	);
};

SectionText.propTypes = {
	children: PropTypes.any,
	isSector: PropTypes.bool,
};

export default SectionText;
